import React, { useState, Component } from 'react';
import styled from "styled-components"
import { render } from 'react-dom';


class TenureSlider extends Component {
    constructor() {
      super()
      this.state = {
        monthsValue: 0,
        daysValue: 7,
        minMonth: 0,
        maxMonth: 120,
        minDay: 7,
        maxDay: 364
      }
      this.handleChangeMonths = this.handleChangeMonths.bind(this)
      this.handleChangeDays = this.handleChangeDays.bind(this)
    }
    
    handleChangeMonths(event) {
    
      if(event.target.value == 0){
        this.setState({
          minDay: 7,
          maxDay: 364,
          monthsValue: event.target.value,
          daysValue: 7,
        })
      }else{
        this.setState({
          minDay: 0,
          maxDay: 30,
          monthsValue: event.target.value,
          daysValue:0
        })
      }
    }

    handleChangeDays(event) {

      this.setState({
        daysValue: event.target.value,
      });
    }

    handleClick = () => {

      let sendData={
        months:0,
        days:7
      };

      sendData.months=this.state.monthsValue
      sendData.days=this.state.daysValue

//condition -->  less than 12 months display in days on UI 

       let today = new Date();
       // console.log(today);
       let MM = parseInt(this.state.monthsValue); 
       //console.log(MM);
  
      if(MM <= 12){

          let newDate = new Date();
          newDate.setMonth(today.getMonth()+MM);
          //console.log(newDate);
    
          let diff = Math.floor((newDate - today)/(1000*60*60*24));
          diff = diff + parseInt(this.state.daysValue);
          //console.log(diff);

          let inputString =   diff + " days" + "<split>" + JSON.stringify(sendData);
          window['autosubmit'](inputString);


      }else{
        let inputString =   this.state.monthsValue +" Months, " + this.state.daysValue + " days" + "<split>" + JSON.stringify(sendData);
        window['autosubmit'](inputString);
      }
//***********************/ 

      //  let inputString =   this.state.monthsValue +" Months, " + this.state.daysValue + " days" + "<split>" + JSON.stringify(sendData);
      // window['autosubmit'](inputString);

      document.getElementById("slider-elem").style.pointerEvents = "none";
      console.log("handleSubmit send to backend: ", JSON.stringify(sendData));


    }
   
    render() {
      return (
        <MainBlock id="slider-elem" >
          <div className="slider-title-block" >
              <div>Months: <span style={{fontWeight: "600"}}>{this.state.monthsValue}</span> </div>
          </div>

          <div className="slidecontainer">
            <label>
              <input className="slider"
                id="monthsRange" 
                type="range" 
                min={this.state.minMonth} max={this.state.maxMonth} //min="0" max="120"
                value={this.state.monthsValue} 
                onChange={this.handleChangeMonths}
                step="1"/>
            </label>

            <div style={{display: "inline-block", padding: "5px 0 0 6px"}}>
              {this.state.minMonth}
            </div>

            <div style={{display: "inline-block",float:"right", padding: "5px 0 0 0"}}>
              {this.state.maxMonth}
            </div>

          </div>

          <div style={{margin: "16px"}}></div>

          <div className="slider-title-block">
              <div>Days: <span style={{fontWeight: "600"}}>{this.state.daysValue} </span></div>
          </div>

          <div className="slidecontainer">
            <label>
              <input className="slider"
                id="daysRange" 
                type="range" 
                min={this.state.minDay} max={this.state.maxDay} //min="7" max="364"
                value={this.state.daysValue} 
                onChange={this.handleChangeDays}
                step="1"/>
            </label>

            <div style={{display: "inline-block", padding: "5px 0 0 6px"}}>
              {this.state.minDay}
            </div>

            <div style={{display: "inline-block",float:"right", padding: "5px 0 0 0"}}>
              {this.state.maxDay}
            </div>

          </div>

          <ActionButton className="action-elem"
          onClick={this.handleClick}>Submit</ActionButton>
          <div className="action-elem" style={{display:"none"}}></div> 

        </MainBlock>
      );
    }
  }


const MainBlock=styled.div`

  padding: 20px 12px 12px 12px;
  border: 0px solid;
  border-radius: 8px;
  background: #fff;
  color: #666;
  margin-top: 12px;
  text-align: left;
  font-size:13px;

  .slider-title-block{
    padding-left: 6px;
    margin-bottom: 4px;
  }
  label {
  }
  input {    
  }

//*********************//

.slidecontainer {
  width: 100%;
  margin-bottom:10px;
}
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  -webkit-transition: .2s;
  transition: opacity .2s;
  cursor: pointer;
}
.slider:hover {
  background: #C0C0C0;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #2c387a
  cursor: pointer;
}
.slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #4CAF50;
  cursor: pointer;
}
`
const ActionButton = styled.div`
  width: 100%
  border: 0px solid #2c387a;
  border-radius: 6px;
  background: #2c387a;
  color: #fff;
  margin-bottom: 0px;
  margin-top:20px;
  font-weight:500;
  
`

export default TenureSlider;